<template>
    <v-dialog width="450px" v-model="isOpenTeamCreate">
        <v-card elevation="0">
            <v-card-title primary-title class="d-flex justify-center">
                <h2 class="font-weight-light primary--text">
                    Creando un Equipo
                </h2>
            </v-card-title>
            <!-- <v-divider></v-divider> -->
            <!-- <v-card elevation="0" class="mx-6 py-2 px-4 my-1">
                <v-row class="pb-3 pt-2">
                    <h4 class="font-weight-light primary--text px-2">Mes al que aplica</h4>
                </v-row>
                <v-divider class="mx-n1"></v-divider>
                <v-row class="d-flex justify-center">
                    <v-col cols="12">
                        <v-menu
                            ref="menu"
                            v-model="menu"  
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date"
                                    label="Fecha"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancelar
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(date)"
                                >
                                    Guardar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card> -->
            <v-card-text class="pa-1">
                <v-card elevation="0" class="mx-6 pt-2 px-4 my-1">
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Filtros
                        </h4>
                    </v-row>
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-select
                            class="pa-4"
                            :items="opciones.cuenta.rol"
                            item-text="human"
                            item-value="encoded"
                            v-model="rol"
                            persistent-hint
                            :hint="
                                rol.length
                                    ? 'Elimine los filtros para ver la selección completa'
                                    : ''
                            "
                            multiple
                            prepend-inner-icon="mdi-gamepad-outline"
                            label="Elija un rol"
                            clearable
                        >
                            <template #item="{ item }">
                                {{ item.human }}
                            </template>
                            <template #selection="{ item }">
                                <v-chip small dark color="red lighten-1">{{
                                    item.human
                                }}</v-chip>
                            </template>
                        </v-select>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="mx-6 pt-2 px-4 my-1">
                    <!-- <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Filtrar por Tipo
                        </h4>
                    </v-row> -->
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-select
                            class="pa-4"
                            :items="opciones.cuenta.tipoComercial"
                            item-text="human"
                            item-value="encoded"
                            v-model="types"
                            persistent-hint
                            :hint="
                                types.length
                                    ? 'Elimine los filtros para ver la selección completa'
                                    : ''
                            "
                            multiple
                            prepend-inner-icon="mdi-filter"
                            label="Elija un tipo"
                            clearable
                        >
                            <template #item="{ item }">
                                {{ item.human }}
                            </template>
                            <template #selection="{ item }">
                                <v-chip small dark color="orange lighten-1">{{
                                    item.human
                                }}</v-chip>
                            </template>
                        </v-select>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="mx-6 pt-2 px-4 my-1">
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Coordinador
                        </h4>
                    </v-row>
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-autocomplete
                            v-if="$store.getters['login/hasManagerPermission']"
                            class="pa-4"
                            :items="comercialesFilter"
                            v-model="form.dutty_manager"
                            item-text="nombreCompleto"
                            return-object
                            prepend-inner-icon="mdi-account-tie-voice-outline"
                            label="Comercial"
                            clearable
                        >
                            <template #item="{ item }">
                                <v-row>
                                    <v-col cols="9">
                                        {{ item.nombreCompleto }}
                                    </v-col>
                                    <v-col cols="3">
                                        <v-icon
                                            :color="
                                                estadoComercial[item.estado]
                                            "
                                            class="
                                                d-flex
                                                justify-center
                                                overline
                                            "
                                        >
                                            mdi-circle
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </template>
                            <template #selection="{ item }">
                                <v-chip small color="lime">{{
                                    item.nombreCompleto
                                }}</v-chip>
                            </template>
                        </v-autocomplete>
                    </v-row>
                </v-card>
                <v-card elevation="0" class="mx-6 pt-2 px-4 my-1">
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Integrantes del Equipo
                        </h4>
                    </v-row>
                    <!-- <v-divider class="mx-n1"></v-divider> -->
                    <v-row no-gutters>
                        <v-autocomplete
                            v-if="$store.getters['login/hasManagerPermission']"
                            class="pa-4"
                            :items="comercialesFilter"
                            v-model="form.commercial_id_arr"
                            item-text="nombreCompleto"
                            item-value="id"
                            multiple
                            prepend-inner-icon="mdi-account"
                            :hint="
                                form.commercial_id_arr.length + ' seleccionados'
                            "
                            persistent-hint
                            label="Comercial"
                            clearable
                        >
                            <template #item="{ item }">
                                <v-row>
                                    <v-col cols="9">
                                        {{ item.nombreCompleto }}
                                    </v-col>
                                    <v-col cols="3">
                                        <v-icon
                                            :color="
                                                estadoComercial[item.estado]
                                            "
                                            class="
                                                d-flex
                                                justify-center
                                                overline
                                            "
                                        >
                                            mdi-circle
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </template>
                            <template #selection="{ item }">
                                <v-chip small color="lime">{{
                                    item.nombreCompleto
                                }}</v-chip>
                            </template>
                        </v-autocomplete>
                    </v-row>
                </v-card>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-tooltip bottom max-width="470px" color="grey darken-3">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="checkSubmitDisabled"
                            color="success"
                            @click="
                                submit();
                                close();
                            "
                            v-bind="attrs"
                            v-on="on"
                        >
                            Crear
                        </v-btn>
                    </template>
                    <v-row>
                        <v-col class="text-justify" cols="8">
                            Este será el equipo establecido para los integrantes
                            seleccionados en el mes en curso. Recuerde que la
                            pertenecia a equipos pasados se desactivará, pasando
                            a ser esta la vigente. Adicionalmente, si el equipo
                            creado contiene comerciales que ya están en otro
                            equipo para este mes, estos dejarán de pertenecer al
                            mismo pasando a pertenecer al que está creando en
                            este momento.
                        </v-col>
                        <v-col cols="4" class="px-6 align-self-center">
                            <v-icon size="90" color="orange">
                                mdi-alert
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-tooltip>
                <v-btn class="ml-1" text color="red" @click="close()">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import defaultTeam from '@/util/areaPersonal/defaultTeam';
import { clone } from '@/util/libUtil.js';
import { estadoComercial } from '@/util/libUtil.js';

export default {
    name: 'AddBadgeDialog',
    data: () => ({
        submitClicked: false,
        types: [],
        rol: [],
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        amount: 0.0,
        selectedComerciales: [],
        estadoComercial,
    }),
    methods: {
        close() {
            (this.rol = []),
                (this.types = []),
                (this.amount = 0.0),
                (this.submitClicked = false),
                (this.selectedComerciales = []);
            this.isOpenTeamCreate = false;
        },
        submit() {
            this.$store.dispatch('areaPersonal/calculadora/addTeam', {});
        },
    },
    computed: {
        checkSubmitDisabled() {
            return (
                this.form.dutty_manager == null ||
                this.form.commercial_id_arr.length == 0
            );
        },
        comercialesFilter() {
            return this.rol.length == 0 && this.types.length == 0
                ? this.comerciales
                : this.comerciales.filter(
                      (comercial) =>
                          this.rol.some((rol) => rol == comercial.rol?.id) ||
                          this.types.some(
                              (type) => type == comercial.tipoComercial
                          )
                  );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        form: {
            get() {
                return this.$store.state.areaPersonal.calculadora.teamForm.form;
            },
            set(value) {
                this.$store.commit('areaPersonal/calculadora/teamsForm', value);
            },
        },
        isOpenTeamCreate: {
            get() {
                let isOpen =
                    this.$store.state.areaPersonal.calculadora.teamForm
                        .isOpenTeamCreate;
                if (isOpen) this.form = clone(defaultTeam);

                return isOpen;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenTeamCreate',
                    value
                );
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
        }),
    },
};
</script>
